// extracted by mini-css-extract-plugin
export default {"wrapper":"Slider_wrapper__uaGbM","thumbnails":"Slider_thumbnails__R05yy","vertical":"Slider_vertical__S1TS0","horizontal":"Slider_horizontal__YorIO"};